module.exports = __webpack_public_path__ + "img/position2.26dc04ba.png";